import * as React from 'react';
import clsx from 'clsx';
import { Label, Switch } from 'ui';

type SettingSwitch = {
  defaultChecked?: boolean;
  name: string;
  label: string;
  hint?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
};

export function SettingSwitch({
  defaultChecked,
  name,
  label,
  hint,
  className,
  disabled,
  checked,
  onCheckedChange,
}: SettingSwitch) {
  return (
    <div>
      <div className={clsx('flex items-center space-x-2 pb-0.5', className)}>
        <Switch
          defaultChecked={defaultChecked}
          checked={checked}
          id={name}
          name={name}
          size="sm"
          disabled={disabled}
          onCheckedChange={onCheckedChange}
        />
        <Label className="cursor-pointer" htmlFor={name}>
          {label}
        </Label>
      </div>
      <p className="pl-[44px] pt-0.5 text-sm text-gray-600">{hint}</p>
    </div>
  );
}
